import { notification } from "ant-design-vue";
import pubMsg from "./pubMsg";
import { Base } from "@/api";
import * as math from "mathjs";
import store from "./../store";
/**
 * 封装的公用方法
 */
export default {
  /* 接口获取 数据字典明细 添加页面的时候用*/
  getSysCodeType: function(code) {
    return new Promise((resolve, reject) => {
      Base.sysCodeTypeFindByCode({ code: code })
        .then(res => {
          if (res.code == 200) {
            const newRes = res.data || [];
            const rets = newRes.map(v => ({
              label: v.baseName,
              value: v.baseCode,
            }));
            resolve(rets);
          } else {
            pubMsg.tipNotification(res.message);
            resolve([]);
          }
        })
        .catch(error => {
          pubMsg.tipNotification(error + "");
          reject(error);
        });
    });
  },
  /* 字典获取 数据字典明细 搜索下拉，显示*/
  findSysCodeType: function(code) {
    return new Promise((resolve, reject) => {
      if (store.state.setting.allSysCode[code]) {
        resolve(store.state.setting.allSysCode[code]);
      } else {
        reject([]);
      }
    });
    // return store.state.setting.allSysCode[code];
  },

  /* 表单去除input框前后空格字符 */
  inputReplace: function(text) {
    return text ? text.replace(/^\s+|\s+$/g, "") : text;
  },

  /* 日期转换 */
  padLeftZero: function(str) {
    return ("00" + str).substr(str.length);
  },
  formatDate: function(date, fmt) {
    if (date) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      const o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          const str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    } else {
      return "--";
    }
  },
  // 公共上传 到阿里云
  fileUpload(data, fileType) {
    console.log(data);
    let formData = new FormData();
    formData.append("file", data.file);
    formData.append("fileType", fileType);
    return new Promise((resolve, reject) => {
      Base.fileUpload(formData)
        .then(res => {
          if (res.code == 200) {
            resolve(res.data);
          } else {
            notification.error({
              message: "操作提示",
              description: res.message,
            });
          }
        })
        .catch(error => {
          notification.error({
            message: "操作提示",
            description: error + "",
          });
          reject(error);
        });
    });
  },

  // 公共上传 到服务器
  uploadLocalFiles(data, fileType) {
    console.log(data);
    let formData = new FormData();
    formData.append("file", data.file);
    formData.append("fileType", fileType);
    return new Promise((resolve, reject) => {
      Base.uploadLocalFiles(formData)
        .then(res => {
          if (res.code == 200) {
            resolve(res.data);
          } else {
            notification.error({
              message: "操作提示",
              description: res.message,
            });
          }
        })
        .catch(error => {
          notification.error({
            message: "操作提示",
            description: error + "",
          });
          reject(error);
        });
    });
  },

  beforeUpload(file, fileType) {
    // console.log(file.type, fileType, "koko");
    if (!fileType.length) return true;
    const isJpgOrPng = fileType.indexOf(file.type) > -1;
    if (!isJpgOrPng) {
      notification.error({
        message: "操作提示",
        description: "只能上传png,jpg,jpeg格式的图片！",
      });
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      notification.error({
        message: "操作提示",
        description: "文件上传不能超过10M！",
      });
    }
    return isJpgOrPng && isLt10M;
  },

  // base64转文件流
  dataURLtoFile(dataURI, type) {
    let binary = atob(dataURI.split(",")[1]);
    let array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    const aa = new Blob([new Uint8Array(array)], { type: type });
    return { file: new File([aa], new Date().getTime() + ".jpg") }; // 命名图片名
  },
  // 下载固定资源
  download(fileUrl, title) {
    let fileName;
    if (title) {
      fileName = title;
    } else {
      let fileList = fileUrl.split("/");
      fileName = fileList[fileList.length - 1];
    }
    let a = document.createElement("a");
    a.href = fileUrl;
    a.target = "_blank";
    a.download = fileName;
    a.click();
  },

  // 导出EXCEL
  formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]));
  },
  // 导出时，当前时间的文字
  daytimeDate: function(date) {
    let o = {
      Y: date.getFullYear(),
      M: date.getMonth() + 1,
      D: date.getDate() > 9 ? date.getDate() : "0" + date.getDate(),
      h: date.getHours() > 9 ? date.getHours() : "0" + date.getHours(),
      m: date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes(),
      s: date.getSeconds(),
    };
    return o.Y + "-" + o.M + "-" + o.D + " " + o.h + ":" + o.m + ":" + o.s;
  },
  // 手机号 中间小星星
  phoneStart(tel) {
    if (tel) {
      var reg = /^(\d{3})\d*(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    } else {
      return tel;
    }
  },
  // 计算 精度问题
  printFn(value) {
    const precision = 14;
    return Number(math.format(value, precision));
  },
  // 表单教验
  rulesReq(value) {
    return {
      required: true,
      message: value,
      trigger: "change",
    };
  },

  /* 学校下拉 页面表格搜索的时候用*/
  getAllSchool: async () => {
    const res = await Base.schoolFindByPage({
      paging: {
        page: 1,
        limit: 999,
      },
    });
    const newRes = res.data || [];
    const rets = newRes.map(v => ({
      label: v.name,
      value: v.id,
    }));
    return rets;
  },
  /* 班级下拉 页面表格搜索的时候用*/
  getAllClass: async id => {
    const res = await Base.gradeClassPage({
      schoolId: id,
      paging: {
        page: 1,
        limit: 999,
      },
    });
    const newRes = res.data || [];
    const rets = newRes.map(v => ({
      label: v.name,
      value: v.id,
    }));
    return rets;
  },

  /* 班组下拉 页面表格搜索的时候用*/
  getTeamManage: async (id, otherData = {}) => {
    const res = await Base.findTeamManageAllSel({
      projectId: id,
      ...otherData,
    });
    const newRes = res.data || [];
    const rets = newRes.map(v => ({
      label: v.name,
      value: v.id,
    }));
    return rets;
  },
};
